export const articles = [
 {
  "id": 202603141000,
  "title": "Tutoriel JavaScript 2026 : Apprendre de zéro à intermédiaire (avec ES2025)",
  "excerpt": "Guide pas-à-pas pour débutants 2026 : variables, fonctions, DOM, événements, fetch API, async/await et nouveautés ES2025. Pratiquez avec des exemples concrets directement dans votre navigateur !",
  "category": "dev",
  "categoryText": "Développement",
  "date": "14 Mars 2026 10:00",
  "datetime": "2026-03-14",
  "img": "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
  "author": "Mohamed Abderrahmann Ahmed",
  "authorAvatar": "https://www.freeiconspng.com/uploads/face-head-man-icon-9.png",
  "readingTime": "10",
  "content": "\n    <h1>Tutoriel JavaScript 2026 : De zéro à intermédiaire avec ES2025</h1>\n\n    <p>JavaScript est le seul langage natif du navigateur — il tourne partout : sites web, applications mobiles (React Native), serveurs (Node.js), jeux, extensions, IA… En 2026, avec les nouveautés ES2025, il est plus puissant et lisible que jamais.</p>\n\n    <p>Ce tuto est fait pour les débutants : on commence de zéro et on monte progressivement. Testez chaque exemple dans la console de votre navigateur (F12) !</p>\n\n    <h2>1. Installation rapide (2026)</h2>\n\n    <ol>\n      <li>Installez <strong>VS Code</strong> (gratuit) + extension <strong>ESLint</strong> + <strong>Prettier</strong>.</li>\n      <li>Créez un fichier <code>index.html</code> avec une balise <code>&lt;script src=\"script.js\"&gt;&lt;/script&gt;</code>.</li>\n      <li>Alternative en ligne : <strong>CodePen</strong>, <strong>StackBlitz</strong> ou <strong>JSFiddle</strong> — zéro setup !</li>\n      <li>Ouvrez le navigateur → F12 → onglet \"Console\" → tapez du JS directement !</li>\n    </ol>\n\n    <h2>2. Variables : var, let, const</h2>\n\n    <pre><code>// ❌ var (ancien, évitez-le)\nvar ancienne = \"à oublier\";\n\n// ✅ let : variable modifiable\nlet age = 25;\nage = 26;   // OK\n\n// ✅ const : constante (recommandé par défaut)\nconst nom = \"Mohamed\";\n// nom = \"autre\" → ❌ ERREUR !\n\n// Types de base\nconst nombre  = 42;          // Number\nconst texte   = \"Salut !\";   // String\nconst actif   = true;        // Boolean\nconst rien    = null;        // Null\nconst inconnu = undefined;   // Undefined\n\nconsole.log(typeof nombre);  // \"number\"</code></pre>\n\n    <h2>3. Template Literals & Strings</h2>\n\n    <pre><code>const prenom = \"Aicha\";\nconst annee  = 2026;\n\n// Ancienne façon ❌\nconsole.log(\"Bonjour \" + prenom + \" en \" + annee);\n\n// Template literal ✅ (backtick `)\nconsole.log(`Bonjour ${prenom} en ${annee} !`);\n\n// Expressions dans les templates\nconsole.log(`2 + 2 = ${2 + 2}`);           // 4\nconsole.log(`Majuscules : ${prenom.toUpperCase()}`);</code></pre>\n\n    <h2>4. Conditions (if / else / ternaire)</h2>\n\n    <pre><code>const note = 14;\n\nif (note >= 16) {\n  console.log(\"Excellent !\");\n} else if (note >= 10) {\n  console.log(\"Passable, continuez !\");\n} else {\n  console.log(\"Redoublement...\");\n}\n\n// Ternaire (version courte)\nconst statut = note >= 10 ? \"Reçu ✅\" : \"Recalé ❌\";\nconsole.log(statut);\n\n// Nullish coalescing ES2025\nconst ville = null;\nconsole.log(ville ?? \"Ville inconnue\");   // \"Ville inconnue\"</code></pre>\n\n    <h2>5. Boucles : for, while, forEach</h2>\n\n    <pre><code>// Boucle classique\nfor (let i = 0; i < 5; i++) {\n  console.log(`Tour ${i}`);\n}\n\n// Tableau + forEach (moderne)\nconst fruits = [\"pomme\", \"banane\", \"kiwi\"];\nfruits.forEach((fruit) => {\n  console.log(`J'aime les ${fruit}s`);\n});\n\n// for...of (ES6+, très propre)\nfor (const fruit of fruits) {\n  console.log(fruit);\n}\n\n// while\nlet compteur = 0;\nwhile (compteur < 3) {\n  console.log(\"Tour\", compteur);\n  compteur++;\n}</code></pre>\n\n    <h2>6. Tableaux & Objets (collections)</h2>\n\n    <pre><code>// Tableau (Array)\nconst nombres = [1, 2, 3, 4];\nnombres.push(5);            // ajoute à la fin\nconsole.log(nombres[0]);    // 1\nconsole.log(nombres.length); // 5\n\n// Méthodes puissantes\nconst doubles = nombres.map(n => n * 2);          // [2,4,6,8,10]\nconst pairs   = nombres.filter(n => n % 2 === 0); // [2,4]\nconst somme   = nombres.reduce((acc, n) => acc + n, 0); // 15\n\n// Objet (clé : valeur)\nconst etudiant = {\n  nom:   \"Ahmed\",\n  age:   22,\n  notes: [15, 12, 18]\n};\nconsole.log(etudiant.nom);        // \"Ahmed\"\netudiant.ville = \"Nouakchott\";   // ajout\n\n// Déstructuration (ES6+)\nconst { nom, age } = etudiant;\nconsole.log(`${nom}, ${age} ans`);</code></pre>\n\n    <h2>7. Fonctions : déclaration, flèche, async</h2>\n\n    <pre><code>// Déclaration classique\nfunction saluer(prenom, age = 20) {\n  return `Salut ${prenom} ! Tu as ${age} ans.`;\n}\nconsole.log(saluer(\"Aicha\"));\nconsole.log(saluer(\"Omar\", 25));\n\n// Fonction fléchée (arrow function) — ES6+\nconst carre = (n) => n * n;\nconsole.log(carre(5));   // 25\n\n// Fonction async/await\nconst obtenirUtilisateur = async (id) => {\n  const reponse = await fetch(`https://jsonplaceholder.typicode.com/users/${id}`);\n  const data    = await reponse.json();\n  return data.name;\n};\n\nobtenirUtilisateur(1).then(nom => console.log(nom));</code></pre>\n\n    <h2>8. Manipulation du DOM</h2>\n\n    <pre><code>// HTML : &lt;button id=\"btn\"&gt;Cliquez&lt;/button&gt;\n//        &lt;p id=\"message\"&gt;&lt;/p&gt;\n\n// Sélectionner des éléments\nconst btn     = document.querySelector(\"#btn\");\nconst message = document.querySelector(\"#message\");\n\n// Écouter un événement\nbtn.addEventListener(\"click\", () => {\n  message.textContent = \"Vous avez cliqué !\";\n  message.style.color = \"#f7df1e\";\n});\n\n// Créer et ajouter un élément\nconst newDiv = document.createElement(\"div\");\nnewDiv.className = \"carte\";\nnewDiv.innerHTML = `&lt;h3&gt;Nouvel élément&lt;/h3&gt;`;\ndocument.body.appendChild(newDiv);</code></pre>\n\n    <h2>9. Gestion des erreurs (try / catch)</h2>\n\n    <pre><code>try {\n  const x = parseInt(prompt(\"Entrez un nombre :\"));\n  if (isNaN(x)) throw new Error(\"Ce n'est pas un nombre !\");\n  console.log(100 / x);\n} catch (err) {\n  console.error(\"Erreur :\", err.message);\n} finally {\n  console.log(\"Toujours exécuté !\");\n}\n\n// Fetch avec gestion d'erreur\nconst getData = async () => {\n  try {\n    const res  = await fetch(\"https://api.example.com/data\");\n    if (!res.ok) throw new Error(`HTTP ${res.status}`);\n    const data = await res.json();\n    return data;\n  } catch (err) {\n    console.error(\"Erreur réseau :\", err);\n  }\n};</code></pre>\n\n    <h2>10. Nouveautés ES2025 à tester (2026)</h2>\n\n    <ul>\n      <li><strong>Object.groupBy()</strong> : grouper des éléments d'un tableau par critère en une ligne.</li>\n      <li><strong>Promise.withResolvers()</strong> : créer des promesses de façon plus propre et flexible.</li>\n      <li><strong>Iterator Helpers</strong> : <code>.map()</code>, <code>.filter()</code> directement sur les itérateurs.</li>\n      <li><strong>Temporal API</strong> (stable) : gestion des dates/heures enfin simple — remplace <code>Date</code>.</li>\n      <li><strong>Pattern Matching</strong> (Stage 4) : expression <code>match</code> pour remplacer les switch complexes.</li>\n    </ul>\n\n    <h2>Plan d'action pour progresser vite</h2>\n\n    <ol>\n      <li>Semaine 1 : Bases + tableaux/objets + fonctions fléchées</li>\n      <li>Semaine 2 : DOM + événements → mini-calculatrice, liste de tâches</li>\n      <li>Semaine 3 : Fetch API + async/await → app météo, quiz JSON</li>\n      <li>Semaine 4+ : Apprenez React ou Vue.js → construisez votre premier vrai projet !</li>\n      <li>Pratique quotidienne : 30-60 min sur <a href=\"https://exercism.org/tracks/javascript\" target=\"_blank\">Exercism</a>, <a href=\"https://www.codewars.com\" target=\"_blank\">Codewars</a> ou <a href=\"https://leetcode.com\" target=\"_blank\">LeetCode</a></li>\n    </ol>\n\n    <h2>Ressources gratuites 2026</h2>\n    <ul>\n      <li>Doc officielle MDN (FR) : <a href=\"https://developer.mozilla.org/fr/docs/Web/JavaScript\" target=\"_blank\">developer.mozilla.org/fr</a></li>\n      <li>Tutoriel complet en français : <a href=\"https://fr.javascript.info\" target=\"_blank\">fr.javascript.info</a></li>\n      <li>YouTube : \"JavaScript 2026 débutant\" (ex. freeCodeCamp cours 8h, Grafikart FR)</li>\n      <li>Interactif : Codecademy, The Odin Project, Mimo</li>\n    </ul>\n\n    <p>Et vous ? Quel est votre premier mini-projet JavaScript ? Partagez en commentaire !</p>\n\n    <p><small>Note : Tous les exemples testés avec Chrome 132 &amp; Node.js 22 LTS – Mars 2026. Bonne programmation ! ⚡</small></p>\n  "
}
 ,
  {
  id: 202602060014,
  title: "Budget 2026 : +104 % pour le ministère de la Transformation Numérique – Ambition louable ou saupoudrage risqué ?",
  excerpt: "Analyse critique du budget de 959,6 millions MRU (+104,6 % vs 2025) alloué à la Transformation Numérique en Mauritanie. Entre accélérateur de modernisation et dangers de surinvestissement mal piloté : transparence réelle, priorités, impact terrain et efficacité des fonds.",
  category: "tech",
  categoryText: "Technologies",
  date: "6 Février 2026 09:30",
  datetime: "2026-02-06",
  img: "https://images.unsplash.com/photo-1517433456452-f9633a875f6f?auto=format&fit=crop&w=800&q=80", // image thématique : budget numérique / graphiques + drapeau Mauritanie ou admin digitale
  author: "Équipe ITmaak TechDev",
  authorAvatar: "https://www.freeiconspng.com/uploads/face-head-man-icon-9.png",
  readingTime: "8",
  content: `
    <h1>Budget 2026 : +104 % pour le ministère de la Transformation Numérique – Ambition louable ou saupoudrage risqué ?</h1>

    <p>En décembre 2025, le projet de budget 2026 a été présenté avec une hausse spectaculaire de <strong>104,6 %</strong> pour le ministère de la Transformation Numérique, de l’Innovation et de la Modernisation de l’Administration : de 468,97 millions MRU en 2025 à <strong>959,6 millions MRU</strong> (environ 24,2 millions USD). Une multiplication par deux en pleine accélération de la Stratégie Nationale IA 2024-2029, du e-gouvernement et de la digitalisation sectorielle (santé, commerce, sécurité routière…).</p>

    <p>Sur le papier, l’ambition est claire et alignée sur les priorités présidentielles : faire du numérique un levier de développement socio-économique, réduire la paperasse, améliorer la transparence et créer des emplois qualifiés. Mais derrière cette croissance budgétaire explosive, plusieurs questions critiques se posent en 2026 : les fonds seront-ils vraiment efficaces ? Priorisés correctement ? Contrôlés ? Et surtout : l’impact réel atteindra-t-il les citoyens les plus éloignés ?</p>

    <h2>Les points positifs indéniables</h2>

    <p>Le ministère peut déjà montrer des réalisations concrètes qui justifient en partie cette hausse :</p>

    <ul>
      <li>Lancement en janvier 2026 du portail <a href="https://transparence.mtnima.gov.mr/">transparence.mtnima.gov.mr</a> : publication en ligne des marchés publics et dépenses depuis août 2024 → pas parfait, mais un pas majeur vers la redevabilité.</li>
      <li>Déploiement depuis fin 2025 d’une solution IA pour la verbalisation automatique des infractions routières → première application visible de l’IA dans la sphère publique.</li>
      <li>Accélération de l’e-santé (Stratégie 2024-2030), du e-commerce (stratégie 2026-2030) et intégration progressive de services via la plateforme Khidmaty.</li>
      <li>Ouverture progressive au satellite LEO pour améliorer la connectivité rurale.</li>
    </ul>

    <p>Ces avancées montrent que l’argent investi ces dernières années n’a pas été totalement gaspillé. La hausse de 2026 vise à consolider et accélérer ces chantiers.</p>

    <h2>Mais les risques et critiques sont nombreux</h2>

    <h3>1. Priorisation discutable et saupoudrage potentiel</h3>
    <p>Avec un budget national 2026 à 132 milliards MRU (+11 %), le numérique capte une part croissante. Mais dans un pays où l’accès internet reste à ~37-40 % (très inégal : Nouakchott vs zones rurales), où l’électricité est instable hors villes, et où le taux d’alphabétisation numérique est faible, doubler le budget sans massifier d’abord la connectivité de base et la formation risque de creuser la fracture numérique plutôt que de la réduire.</p>

    <p>Question clé : combien va vraiment aux infrastructures inclusives (fibre, 4G/5G rurale, hotspots publics, formation) vs aux projets prestige (IA avancée, applications gouvernementales sophistiquées utilisées par <10 % de la population) ?</p>

    <h3>2. Transparence : un pas en avant, mais pas suffisant</h3>
    <p>Le portail transparence est une excellente initiative… mais il concerne uniquement les dépenses du ministère lui-même. Où est la publication exhaustive et en temps réel des projets financés par les 959 millions MRU ? Quid des audits indépendants post-exécution ? Des pénalités en cas de retard ou surcoût ? Sans ces garde-fous, le risque de favoritisme dans les marchés publics (très présent historiquement) reste élevé, même avec un portail.</p>

    <h3>3. Efficacité et absorption des fonds</h3>
    <p>Les ministères mauritaniens peinent souvent à absorber 100 % de leurs budgets d’investissement (délais, procédures, manque de capacités). Doubler les crédits sans renforcer drastiquement les équipes projet (PMO, procurement digital, suivi-évaluation) risque de générer des reports massifs ou des dépenses mal utilisées en fin d’année.</p>

    <h3>4. Fiscalité numérique : l’autre face de la pièce</h3>
    <p>La Loi de Finances 2026 introduit une taxe de 0,1 % sur les transactions électroniques > 5 000 MRU et 10 % sur les commissions des agents. Louable pour élargir l’assiette fiscale… mais dans un pays où le mobile money et les paiements digitaux sont encore naissants, cette mesure risque de freiner l’adoption plutôt que de l’accélérer. Contradiction avec l’objectif de massification numérique ?</p>

    <h2>Ce qui manque pour que ce budget soit un vrai succès</h2>

    <ol>
      <li>Un KPI clair et public par axe (ex. : % de services 100 % en ligne, taux d’adoption citoyen, réduction mesurable des délais administratifs, emplois IT créés).</li>
      <li>Une priorisation affichée : au moins 40-50 % du budget 2026 vers la connectivité inclusive + formation massive (jeunes, femmes, fonctionnaires, zones rurales).</li>
      <li>Partenariats renforcés avec le privé local (startups mauritaniennes) plutôt que tout confier à des géants étrangers.</li>
      <li>Audit citoyen et tiers indépendant systématique sur les gros projets.</li>
    </ol>

    <h2>Conclusion : une opportunité historique… à ne pas rater</h2>

    <p>Ce +104 % n’est pas intrinsèquement mauvais : la Mauritanie a besoin d’un saut numérique pour rattraper son retard et valoriser ses ressources (gaz, pêche, mines, position atlantique). Mais sans pilotage rigoureux, sans focus inclusion et sans transparence renforcée, ce budget risque de devenir un énième exemple de « bonne intention, mauvaise exécution ».</p>

    <p>En 2026, le vrai test ne sera pas le montant alloué, mais les résultats tangibles pour le citoyen moyen : moins de files d’attente ? Services accessibles depuis un téléphone basique en brousse ? Moins de corruption visible ?</p>

    <p>Le ministère a les moyens. Reste à prouver qu’il a aussi la méthode.</p>

    <p><small>Basé sur les données officielles (Loi de Finances 2026, communiqués du ministère, Agence Ecofin, Digital Business Africa, janvier-février 2026). Les opinions exprimées sont personnelles.</small></p>

    <p>Et vous, que pensez-vous de cette hausse budgétaire ? Trop ambitieuse ? Pas assez ? Partagez en commentaire !</p>
  `
},
  {
  id: 202602042000,
  title: "Clean Code : Écrire un code maintenable et évolutif en 2026",
  excerpt: "Guide pratique des principes Clean Code (Uncle Bob) adaptés à 2026 : noms significatifs, fonctions courtes, SOLID, tests, refactor, IA-assisted reviews… Exemples en JavaScript/TypeScript et Python pour booster la lisibilité et la maintenabilité.",
  category: "dev",
  categoryText: "Développement",
  date: "4 Février 2026 20:00",
  datetime: "2026-02-04",
  img: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80", // image code propre / refactoring thématique
  author: "Mohamed Abderrahmann Ahmed",
  authorAvatar: "https://www.freeiconspng.com/uploads/face-head-man-icon-9.png",
  readingTime: "7",
  content: `
    <h1>Clean Code : Écrire un code maintenable et évolutif en 2026</h1>

    <p>En 2026, avec l'essor de l'IA (Copilot, Cursor, GitHub Copilot Workspace), des équipes distribuées et des projets qui vivent 10+ ans, le <strong>Clean Code</strong> n'est plus un "nice to have" : c'est une nécessité pour survivre à la dette technique, aux onboardings rapides et aux reviews AI-humain hybrides.</p>

    <p>Robert C. Martin ("Uncle Bob") a popularisé ces idées dans <em>Clean Code</em> (2008, 2e éd. 2025). Le principe fondamental : <strong>le code doit être lu beaucoup plus qu'il n'est écrit</strong>. Un bon code est celui qu'un autre dev (ou vous dans 6 mois) comprend en 30 secondes.</p>

    <h2>1. Noms significatifs (le plus important !)</h2>

    <p>Un bon nom révèle l'intention : pourquoi la variable existe, quoi elle fait, comment elle est utilisée.</p>

    <ul>
      <li>Mauvais : <code>int d; // elapsed time in days</code></li>
      <li>Bon : <code>int daysSinceLastLogin;</code></li>
      <li>En 2026 (TypeScript) : <code>const userAgeInYears: number = calculateAge(birthDate);</code></li>
      <li>Python : <code>nombre_de_jours_ecoules = datetime.now() - date_inscription</code> (snake_case par convention PEP 8)</li>
    </ul>

    <p><strong>Règles</strong> : Prononçable, cherchable, intention-révélatrice. Évitez les abréviations sauf si universelles (id, url, db).</p>

    <h2>2. Fonctions : courtes, font une seule chose (SRP)</h2>

    <p>Une fonction doit faire <strong>une seule chose</strong>, bien, et être facile à nommer.</p>

    <pre><code>// Mauvais (fait trop de choses)
function processUserData(user) {
  // validate
  // save to db
  // send email
  // log
}

// Bon (chaque fait une chose)
function validateUser(user) { ... }
async function saveUserToDatabase(user) { ... }
async function sendWelcomeEmail(user) { ... }
function logUserAction(user, action) { ... }

// Appel clair
if (validateUser(user)) {
  await saveUserToDatabase(user);
  await sendWelcomeEmail(user);
}</code></pre>

    <p><strong>Idéal</strong> : 5-15 lignes max. Si plus long → refactor en fonctions privées ou helpers.</p>

    <h2>3. Commentaires : le moins possible, mais utiles</h2>

    <p>Le meilleur commentaire est un bon nom de variable/fonction. Commentez le <strong>pourquoi</strong>, pas le <strong>quoi</strong>.</p>

    <pre><code>// Mauvais
// Boucle sur les users pour trouver l'admin
for (const u of users) { ... }

// Bon
// On autorise plusieurs admins legacy → on prend le premier trouvé
// TODO: migrer vers role-based après refactor RBAC v2
const firstAdmin = users.find(u => u.isAdmin);</code></pre>

    <p>En 2026 : laissez l'IA (Copilot) générer les JSDoc / docstrings automatiques, puis corrigez le "pourquoi".</p>

    <h2>4. Formatage & Consistance</h2>

    <ul>
      <li>Une équipe = un style (Prettier + ESLint / Black + Ruff en Python / Biome en JS/TS 2026)</li>
      <li>Vertical density : code lié proche (variables près de leur usage)</li>
      <li>Horizontal : max 80-100 colonnes (encore vrai avec écrans larges !)</li>
    </ul>

    <h2>5. Gestion des erreurs & Exceptions</h2>

    <p>Ne pas polluer le flux heureux avec des if/else error-checking.</p>

    <pre><code>// Mauvais
if (file) {
  if (parse(file)) {
    // ...
  } else {
    throw new Error("Parse failed");
  }
} else {
  throw new Error("No file");
}

// Bon (Python)
try:
    data = parse_config(file_path)
except FileNotFoundError:
    logger.error(f"Fichier {file_path} introuvable")
    raise ConfigError("Configuration manquante") from None
except json.JSONDecodeError as e:
    raise ConfigError("JSON invalide") from e

// Bon (JS/TS async)
async function loadUser(id: string): Promise<User> {
  const response = await fetchUserApi(id);
  if (!response.ok) throw new ApiError("Utilisateur non trouvé", response.status);
  return response.json();
}</code></pre>

    <h2>6. Objets & Structures de données</h2>

    <p>Objets : pour comportement + données cachées (encapsulation).<br>
    Data structures : pour exposer les données (DTO, records TS 2025+).</p>

    <pre><code>// TS Record (2026 style)
type UserDTO = Record<string, unknown>; // ou mieux : interface User { id: string; name: string; }

// Python dataclass (depuis 3.7, boost en 3.14)
from dataclasses import dataclass

@dataclass(frozen=True)
class User:
    id: str
    name: str
    email: str</code></pre>

    <h2>7. Principes SOLID (rappel rapide 2026)</h2>

    <ul>
      <li><strong>S</strong>ingle Responsibility : une classe → un job</li>
      <li><strong>O</strong>pen/Closed : ouvert extension, fermé modification</li>
      <li><strong>L</strong>iskov Substitution : sous-classes interchangeables</li>
      <li><strong>I</strong>nterface Segregation : interfaces fines</li>
      <li><strong>D</strong>ependency Inversion : dépendre d'abstractions</li>
    </ul>

    <p>En 2026 : appliquez SOLID modérément (pas dogmatique) + DDD lite pour domaines complexes.</p>

    <h2>8. Tests & Refactoring</h2>

    <p>Clean Code = code testable. Écrivez d'abord les tests (TDD idéal).</p>

    <ul>
      <li>Unit tests rapides (Jest/Pytest)</li>
      <li>Couverture >80 % sur code métier</li>
      <li>Refactor sans peur grâce aux tests</li>
    </ul>

    <h2>9. Tendances 2026</h2>

    <ul>
      <li><strong>AI code review</strong> : Copilot / Sonar / CodeRabbit analysent style + bugs → focus humain sur l'intention business</li>
      <li><strong>Machine-readable code</strong> : noms explicites aident l'IA à générer/refactor mieux</li>
      <li><strong>Langages modernes</strong> : TypeScript (quasi obligatoire), Python type hints + Ruff, Go/Rust pour perf critique</li>
    </ul>

    <h2>Conclusion : Clean Code = professionnalisme</h2>

    <p>En 2026, le Clean Code n'est pas une mode : c'est ce qui sépare les devs qui maintiennent des systèmes 10 ans des autres. Commencez petit :</p>

    <ol>
      <li>Activez Prettier/ESLint/Black + Ruff</li>
      <li>Revoyez noms + fonctions trop longues dans votre dernier projet</li>
      <li>Ajoutez 1 test par jour</li>
      <li>Lisez <em>Clean Code 2e éd.</em> ou <em>Clean Code JS</em> sur GitHub</li>
    </ol>


    <p><small>Note : Inspiré de Clean Code (Uncle Bob, 2e éd. 2025), Clean Code JS (GitHub), PEP 8/Python, tendances 2026 (AI reviews, TypeScript dominance).</small></p>
  `
},
  {
  id: 202602041500,
  title: "Freelance remote ou salarié IT en Mauritanie : quel choix pour votre carrière en 2026 ?",
  excerpt: "Comparatif actualisé 2026 Mauritanie : salariat local vs freelance international (remote). Stabilité vs revenus ×3-5, protection sociale, fiscalité, internet & vie à Nouakchott. Quelle voie selon votre profil ?",
  category: "career",
  categoryText: "Carrière IT en Mauritanie",
  date: "4 Février 2026",
  datetime: "2026-02-04",
  img: "https://f.hellowork.com/helloworkplace/2024/05/freelance-salaries.jpg", 
  author: "Équipe ITmaak TechDev",
  authorAvatar: "https://techdev.itmaak.com/img/logo.6ed77e12.png",
  readingTime: "6",
  content: `
  <h1>Freelance remote ou salarié IT en Mauritanie : quel choix pour votre carrière en 2026 ?</h1>

  <p>En 2026, le marché IT mauritanien reste dominé par les emplois salariés dans les institutions (banques, télécoms, mines, ONG internationales comme PAM, UNICEF, Banque Mondiale) et quelques ESN locales ou filiales. Mais pour beaucoup de développeurs, data scientists, spécialistes cybersécurité ou IA, le vrai game changer est le <strong>freelance remote international</strong> : clients européens, américains, du Golfe via Upwork, Freelancer, Malt, LinkedIn ou réseau direct.</p>

  <p>Ce comparatif 2026 est adapté à la réalité mauritanienne : salaires locaux en Ouguiya (MRU), coût de la vie à Nouakchott, qualité internet (fibre + Starlink de plus en plus répandu), fiscalité simplifiée pour auto-entrepreneurs et absence de portage salarial local structuré.</p>

  <h2>1. Le salariat IT en Mauritanie en 2026</h2>

  <h3>Avantages majeurs</h3>
  <ul>
    <li><strong>Stabilité & paiement régulier</strong> : Salaire fixe mensuel en MRU, même en cas de coupure internet ou instabilité projet.</li>
    <li><strong>Protection sociale de base</strong> : CNSS (retraite, maladie), congés payés, parfois mutuelle entreprise (surtout multinationales ou ONG).</li>
    <li><strong>Pas d’administratif lourd</strong> : Pas de facturation, TVA, relances clients. L’employeur gère tout.</li>
    <li><strong>Réseau local & évolution</strong> : Contacts utiles à Nouakchott, formation parfois financée, évolution vers chef projet / IT manager dans banque ou ministère.</li>
  </ul>

  <h3>Inconvénients & réalités 2026</h3>
  <ul>
    <li><strong>Plafond salarial très bas</strong> : Développeur / programmeur : 180 000 – 450 000 MRU/mois (~420 – 1 050 €). Senior / lead : rarement au-dessus de 600-800 000 MRU (~1 400 – 1 850 €). IT Manager ~800 000-1 200 000 MRU.</li>
    <li><strong>Moins de technos modernes</strong> : Beaucoup de projets legacy (PHP, Java old school, Access…) ; peu d’IA, cloud avancé, DevOps.</li>
    <li><strong>Dépendance & lenteur</strong> : Hiérarchie lourde, projets publics lents, risque de retard paiement (surtout administration).</li>
    <li><strong>Concurrence locale</strong> : Diplômés IMIT, Université de Nouakchott, bootcamps → beaucoup de juniors sur le marché.</li>
  </ul>

  <h2>2. Le freelance remote international depuis la Mauritanie en 2026</h2>

  <h3>Avantages majeurs</h3>
  <ul>
    <li><strong>Revenus multipliés par 3 à 8</strong> : TJM remote 15-35 $/h junior/mid → 25-60 $/h senior/expert (React, Node, Python, Flutter, IA, cybersécu). → Revenu mensuel réaliste 1 500 – 6 000 $+ (après 160-200 h facturées).</li>
    <li><strong>Liberté totale</strong> : Clients Europe/USA/Golfe, full remote, choix missions (IA, mobile, web3…), horaires adaptés à la prière / famille, digital nomad possible (Dubaï, Maroc…).</li>
    <li><strong>Évolution ultra-rapide</strong> : Missions variées → apprentissage constant (AWS, Azure, LLM, React Native…). CV devient très attractif.</li>
    <li><strong>Plateformes accessibles</strong> : Upwork, Freelancer, Toptal, PeoplePerHour, Malt (France), LinkedIn. Beaucoup de Mauritaniens cartonnent depuis 2023-2024.</li>
    <li><strong>Fiscalité allégée</strong> : Auto-entrepreneur ou régime simplifié → déclaration IR + TVA si > seuil. Pas de charges sociales lourdes comme en Europe.</li>
  </ul>

  <h3>Inconvénients & réalités 2026</h3>
  <ul>
    <li><strong>Instabilité & prospection</strong> : Périodes sans client = zéro revenu. Faut réseau + portfolio solide (GitHub, certifications).</li>
    <li><strong>Internet & électricité</strong> : Fibre à Nouakchott ok, mais coupures fréquentes → Starlink quasi indispensable pour remote sérieux (~30-40 $/mois).</li>
    <li><strong>Pas de chômage / retraite forte</strong> : CNSS facultative pour indépendants → faut épargner soi-même (compte crypto/USDT ou banque).</li>
    <li><strong>Paiements internationaux</strong> : Wise, Payoneer, PayPal (limité), crypto → commissions + délai. Change MRU/USD/EUR fluctuant.</li>
    <li><strong>Solitude & équilibre vie pro/perso</strong> : Pas d’équipe locale, frontière floue, risque burn-out si trop d’heures.</li>
  </ul>

  <h2>Comparatif chiffré rapide – Mauritanie 2026 (estimations réalistes)</h2>

  <table>
    <thead>
      <tr>
        <th>Critère</th>
        <th>Salarié IT local (senior)</th>
        <th>Freelance remote international (senior)</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Revenu net mensuel moyen</td>
        <td>300 000 – 800 000 MRU (~700 – 1 850 €)</td>
        <td>1 500 – 5 000 $+ (~650 000 – 2 150 000 MRU)</td>
      </tr>
      <tr>
        <td>Heures facturées / mois</td>
        <td>~160-180</td>
        <td>~120-180 (repos, prospection)</td>
      </tr>
      <tr>
        <td>Stabilité revenu</td>
        <td>Bonne</td>
        <td>Moyenne (si 3-5 clients récurrents)</td>
      </tr>
      <tr>
        <td>Flexibilité horaire/lieu</td>
        <td>Faible à moyenne</td>
        <td>Excellente</td>
      </tr>
      <tr>
        <td>Protection sociale</td>
        <td>Bonne (CNSS + mutuelle)</td>
        <td>Faible à moyenne (auto-gérée)</td>
      </tr>
      <tr>
        <td>Évolution compétences</td>
        <td>Moyenne</td>
        <td>Très rapide</td>
      </tr>
    </tbody>
  </table>

  <h2>Grille de décision 2026 : quel statut pour vous en Mauritanie ?</h2>

  <p><strong>Choisissez le salariat local si vous priorisez :</strong></p>
  <ul>
    <li>Stabilité familiale & revenu fixe en MRU</li>
    <li>Travailler en équipe sur place à Nouakchott</li>
    <li>Vous êtes junior ou mid-level sans anglais courant</li>
    <li>Phase de vie avec crédit, famille, besoin de sécurité</li>
  </ul>

  <p><strong>Choisissez le freelance remote international si vous priorisez :</strong></p>
  <ul>
    <li>Revenus 3× à 8× supérieurs</li>
    <li>Travailler sur stacks modernes (React, Python/IA, Flutter, AWS…)</li>
    <li>Anglais technique correct + bon portfolio</li>
    <li>Investir dans Starlink, formations Udemy/Coursera, certifications</li>
  </ul>

  <h2>Conclusion : le hybride ou le remote domine en 2026</h2>

  <p>En Mauritanie, le salariat local reste une bonne rampe de lancement (2-4 ans pour monter compétences/réseau). Mais pour exploser revenus et carrière, la majorité des talents IT qualifiés passent au **freelance remote** dès que possible.</p>

  <p>La vraie question : <strong>quel niveau de risque et quel style de vie voulez-vous ?</strong> Internet fiable + anglais + spécialisation = jackpot possible depuis Nouakchott.</p>

  <p>Peu importe le chemin, l’IT reste ultra-porteur. Investissez dans l’anglais, GitHub, certifications cloud/IA → vous gagnerez dans les deux mondes.</p>


  <p><small>Note : Chiffres indicatifs février 2026 – sources : Paylab, Multiplier, AfricaShore, Upwork trends, témoignages développeurs mauritaniens LinkedIn/Reddit, taux change ~430 MRU/USD.</small></p>
  `
},
  {
    id: 202601152210,
    title: "ECMAScript 2025 et perspectives 2026 : Analyse détaillée des évolutions du langage JavaScript",
    excerpt: "Examen exhaustif des fonctionnalités finalisées dans ES2025 (juin 2025) et des propositions avancées (stage 4+) pour ES2026, avec exemples concrets, impacts sur le développement quotidien et recommandations d’adoption.",
    category: "dev",
    categoryText: "Développement",
    date: "15 Janvier 2026  22:10",
    datetime: "2026-01-15",
    img: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?auto=format&fit=crop&w=800&q=80",
    author: "Équipe ITmaak TechDev",
  authorAvatar: "https://techdev.itmaak.com/img/logo.6ed77e12.png",
    readingTime: "6",
    content: `
      <h2 id="introduction">Introduction : L’évolution continue d’ECMAScript</h2>
      <p>JavaScript reste le langage le plus utilisé au monde en 2026, grâce à son processus d’évolution ouvert via TC39. L’édition ES2025 (16ᵉ, finalisée le 25 juin 2025 par l’Assemblée générale Ecma) introduit des outils puissants pour l’itération, les collections, les imports non-JS et la gestion des ressources. ES2026 intègre déjà des ajouts confirmés comme Upsert (stage 4 janvier 2026), tandis que Temporal progresse lentement (stage 3 avancé). Ces changements réduisent le boilerplate, améliorent la sécurité et préparent le langage aux workloads asynchrones, scientifiques et edge.</p>

      <h2 id="processus-tc39">Rappel du processus TC39</h2>
      <p>Les propositions suivent 5 stages : 0 (idée), 1 (problème formel), 2 (brouillon), 3 (candidat — implémentations expérimentales), 4 (finalisé — inclus dans la spec). Seules les stage 4 deviennent standard. ES2025 regroupe 9 propositions stage 4 de 2024-2025.</p>

      <h2 id="es2025-detail">Fonctionnalités détaillées d’ECMAScript 2025</h2>

      <h3>1. Iterator Helpers (new Iterator global)</h3>
      <p>Les itérateurs gagnent des méthodes chainables : .map(), .filter(), .take(), .drop(), .flatMap(), .reduce(), .toArray(), .find(), .findLast(), etc. Cela rend le traitement paresseux aussi ergonomique que les arrays.</p>
      <pre><code>const naturals = {
  *[Symbol.iterator]() { let n = 0; while (true) yield n++; }
};

const evensDoubled = naturals
  .filter(n => n % 2 === 0)
  .map(n => n * 2)
  .take(5)
  .toArray();

console.log(evensDoubled); // [0, 4, 8, 12, 16]</code></pre>
      <p>Avantages : code déclaratif, lazy evaluation (mémoire/CPU), compatibilité async via async iterators.</p>

      <h3>2. Nouvelles méthodes Set</h3>
      <p>Set.prototype gagne union(), intersection(), difference(), symmetricDifference(), isSubsetOf(), isSupersetOf(), isDisjointFrom(). Opérations ensemblistes natives, rapides (O(n)).</p>
      <pre><code>const admins = new Set(["alice", "bob"]);
const editors = new Set(["bob", "charlie"]);
const all = admins.union(editors); // Set { "alice", "bob", "charlie" }
console.log(admins.isSubsetOf(all)); // true</code></pre>

      <h3>3. Import JSON & Import Attributes</h3>
      <p>Import direct de JSON (et autres) sans loader : import data from "./config.json" with { type: "json" }; Attributs pour assert/validate imports (ex. integrity, type).</p>

      <h3>4. RegExp.escape() + Inline flags</h3>
      <p>RegExp.escape(str) échappe les meta-characters. Flags inline : /pattern/im ; /pattern/gimsuy ; permet de changer flags en milieu de regex.</p>

      <h3>5. Promise.try(fn)</h3>
      <p>Exécute fn() et retourne toujours un Promise, même si sync. Utile pour uniformiser try/catch async/sync.</p>
      <pre><code>Promise.try(() => "sync value")
  .then(v => console.log(v))
  .catch(e => console.error(e));</code></pre>

      <h3>6. Float16Array & Math.f16round</h3>
      <p>TypedArray 16-bit float pour ML, graphiques, WebGPU. Réduit mémoire (moitié vs Float32).</p>

      <h3>7. Array.fromAsync(iterable)</h3>
      <p>Collecte async iterable en array : await Array.fromAsync(asyncGen()).</p>

      <h3>8. Explicit Resource Management (using / await using)</h3>
      <p>Gestion auto des dispose() comme en C#/Python. Idéal pour fichiers, DB connexions, locks.</p>
      <pre><code>{
  using file = await Deno.open("./data.txt", { write: true });
  await file.write(new TextEncoder().encode("Log 2026"));
  // auto dispose à sortie bloc
}</code></pre>

      <h3>9. Error.isError(value)</h3>
      <p>Détecte Error cross-realm (iframe, vm), contrairement à instanceof.</p>

      <h2 id="es2026">Perspectives ES2026 (janvier 2026)</h2>
      <p>Upsert (Map/WeakMap.upsert) stage 4 : atomique insert-or-update. Temporal (stage 3 avancé) : nouvelle API date/time robuste (ZonedDateTime, PlainDate, etc.). Records & Tuples (immutables) stage 3.</p>

      <h2 id="impacts">Impacts sur les projets 2026</h2>
      <ul>
        <li>Code plus déclaratif et sûr (moins d’erreurs manuelles)</li>
        <li>Meilleure perf pour big data / streaming</li>
        <li>Adoption progressive : Babel / TypeScript polyfills déjà disponibles</li>
        <li>Recommandation : migrer vers using pour ressources, Iterator helpers pour pipelines</li>
      </ul>

      <h2 id="conclusion">Conclusion</h2>
      <p>ES2025 marque une maturité accrue pour les patterns asynchrones et collections. ES2026 consolidera avec des outils plus ergonomiques. Les devs devraient tester ces features en staging pour anticiper les standards 2026-2027.</p>
    `
  },
  {
    id: 202602032243,
    title: "Angular, React ou Vue : quel framework choisir pour un projet professionnel en 2026 ?",
    excerpt: "Analyse comparative approfondie des trois principaux frameworks front-end : Angular, React et Vue.js. Évaluation des critères techniques, écosystème, courbe d'apprentissage et adéquation selon le type de projet professionnel.",
    category: "dev",
    categoryText: "Développement",
    date: "03 Février 2026   22:43",
    datetime: "2026-02-03",
    img: "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=800&q=80",
    author: "Mohamed Abderrahmann Ahmed",
    authorAvatar: "https://www.freeiconspng.com/uploads/face-head-man-icon-9.png",
    readingTime: "5",
 content: `
      <h2 id="introduction">Introduction : Un écosystème front-end en constante évolution</h2>
      <p>En février 2026, le choix d'un framework JavaScript pour un projet professionnel reste une décision stratégique aux implications durables. Entre la structure complète d'Angular, la flexibilité extrême de React et l'équilibre intuitif de Vue, chaque solution conserve sa philosophie propre. Cet article analyse les forces, faiblesses et cas d'utilisation optimaux pour ces trois leaders, en intégrant les évolutions majeures de fin 2025 et début 2026.</p>

      <h2 id="analyse-comparative">Analyse comparative technique 2026</h2>
      
      <h3>1. Angular (v21+) : L'écosystème complet et zoneless</h3>
      <p><strong>Philosophie :</strong> Framework "batteries-included" maintenu par Google. Solution tout-en-un avec routing, state management, CLI, testing et tooling intégré.</p>
      
      <h4>Points forts :</h4>
      <ul>
        <li><strong>Architecture cohérente :</strong> TypeScript natif, standalone components par défaut, zoneless stable depuis v20.2/v21</li>
        <li><strong>Productivité long terme :</strong> CLI ultra-puissant, génération de code, refactoring automatisé, AI tooling intégré</li>
        <li><strong>Performances modernes :</strong> Ivy + Signals matures, réactivité fine, zoneless (supprime Zone.js)</li>
        <li><strong>Enterprise-ready :</strong> DI avancée, modules optionnels, testing robuste</li>
        <li><strong>SSR/hydratation optimisée :</strong> Angular Universal + hydration non-destructive performante</li>
      </ul>
      
      <h4>Points d'attention :</h4>
      <ul>
        <li>Courbe d'apprentissage toujours significative (même si standalone simplifie)</li>
        <li>Bundle initial plus lourd que React/Vue</li>
        <li>Moins de flexibilité dans les choix d'outils externes</li>
      </ul>

      <h3>2. React (v19.2+) : La bibliothèque flexible et serveur-centrique</h3>
      <p><strong>Philosophie :</strong> Bibliothèque UI maintenue par Meta, centrée composants + Virtual DOM. Écosystème communautaire très riche.</p>
      
      <h4>Points forts :</h4>
      <ul>
        <li><strong>Flexibilité maximale :</strong> Choix libre (state, routing, meta-frameworks)</li>
        <li><strong>Écosystème immense :</strong> Solutions pour tout, communauté #1 pour le recrutement</li>
        <li><strong>React Server Components & Actions :</strong> Architecture hybride client/serveur très mature en 2026</li>
        <li><strong>Évolutions récentes :</strong> Activity API, useEffectEvent, améliorations perf rendering</li>
        <li><strong>Portabilité :</strong> React Native, React pour VR/AR, etc.</li>
      </ul>
      
      <h4>Points d'attention :</h4>
      <ul>
        <li>Surcharge décisionnelle (choix infinis de libs)</li>
        <li>Fragmentation persistante (hooks vs RSC vs anciennes approches)</li>
        <li>Veille nécessaire face aux évolutions rapides</li>
      </ul>

      <h3>3. Vue.js (v3.5+) : L'approche progressive et performante</h3>
      <p><strong>Philosophie :</strong> Framework progressif créé par Evan You. Équilibre parfait entre simplicité et puissance (Options API + Composition API).</p>
      
      <h4>Points forts :</h4>
      <ul>
        <li><strong>Courbe d'apprentissage très douce :</strong> Documentation exemplaire, adoption graduelle</li>
        <li><strong>Performance de pointe :</strong> Reactivité fine, compilation avancée, Vapor Mode (preview) vers DOM natif sans VDOM</li>
        <li><strong>Écosystème cohérent :</strong> Vue Router, Pinia, Vite (standard de facto), Nuxt</li>
        <li><strong>Syntaxe élégante :</strong> Single File Components intuitifs</li>
        <li><strong>Reactivity améliorée :</strong> Préparations Vue 3.6 (perf massive en beta)</li>
      </ul>
      
      <h4>Points d'attention :</h4>
      <ul>
        <li>Écosystème moins massif que React (mais plus cohérent et stable)</li>
        <li>Adoption moindre dans certaines grandes entreprises legacy</li>
        <li>Dualité Options/Composition API (moins problématique en 2026)</li>
      </ul>

      <h2 id="benchmarks">Performances et bundle size (2026)</h2>
      <p>Les écarts de performance se sont encore réduits grâce aux optimisations build-time et réactivité fine, mais des spécificités demeurent :</p>
      
      <table>
        <thead>
          <tr>
            <th>Critère</th>
            <th>Angular 21+</th>
            <th>React 19.2+</th>
            <th>Vue 3.5+</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Bundle initial (Hello World gzipped)</td>
            <td>~55-65 KB</td>
            <td>~38-45 KB</td>
            <td>~25-32 KB</td>
          </tr>
          <tr>
            <td>Time To Interactive (moyenne apps réelles)</td>
            <td>Bonne (zoneless aide beaucoup)</td>
            <td>Très bonne (RSC)</td>
            <td>Excellente</td>
          </tr>
          <tr>
            <td>Memory usage (apps complexes)</td>
            <td>Modéré à élevé</td>
            <td>Modéré</td>
            <td>Faible</td>
          </tr>
          <tr>
            <td>SSR / Hydratation perf</td>
            <td>Angular Universal + zoneless</td>
            <td>Next.js / App Router + RSC</td>
            <td>Nuxt 4 / SSR natif</td>
          </tr>
        </tbody>
      </table>

      <h2 id="cas-utilisation">Cas d'utilisation recommandés 2026</h2>
      
      <h3>Angular : Quand choisir ?</h3>
      <ul>
        <li>Applications d'entreprise très complexes (CRM, ERP, finance)</li>
        <li>Équipes grandes et structurées voulant une cohérence forte</li>
        <li>Projets à très longue maintenance (10+ ans)</li>
        <li>Équipes venant de Java/.NET/C# (patterns familiers)</li>
      </ul>
      
      <h3>React : Quand choisir ?</h3>
      <ul>
        <li>Besoin de flexibilité maximale et innovation rapide</li>
        <li>Applications web + mobile (via React Native)</li>
        <li>Équipes distribuées / recrutement facile</li>
        <li>Sites marketing, e-commerce, dashboards avec Next.js</li>
      </ul>
      
      <h3>Vue.js : Quand choisir ?</h3>
      <ul>
        <li>Progressive enhancement sur sites existants</li>
        <li>Équipes petites/moyennes cherchant productivité immédiate</li>
        <li>Applications très performantes (dashboards temps réel, data-heavy)</li>
        <li>Priorité à l'expérience développeur (Vite, DevTools excellents)</li>
      </ul>

      <h2 id="tendances-2026">Tendances 2026 et évolutions à surveiller</h2>
      
      <h3>1. Réactivité fine généralisée</h3>
      <p>Signals (Angular), Reactivity améliorée (Vue 3.6 preview), use() et RSC (React) → rendus ultra-optimisés partout.</p>
      
      <h3>2. Architectures hybrides server-first</h3>
      <p>React Server Components leader, Nuxt Layers / Server Routes, Analog (Angular) + zoneless SSR.</p>
      
      <h3>3. Compilation et build ultra-rapide</h3>
      <p>Vite/Turbopack/esbuild standard. Vapor Mode (Vue) et resumability (inspirations Qwik) gagnent du terrain.</p>
      
      <h3>4. AI dans le dev tooling</h3>
      <p>Angular intègre fortement l'AI (v21), assistants dans VSCode/WebStorm, génération de code/context.</p>

      <h2 id="decision">Grille de décision pour votre projet 2026</h2>
      
      <p><strong>Choisissez Angular si :</strong> Équipe grande, projet complexe/long terme, besoin d'architecture prescriptive, intérêt pour zoneless + AI tooling.</p>
      
      <p><strong>Choisissez React si :</strong> Flexibilité prioritaire, web + mobile, équipe à recruter facilement, usage intensif de meta-frameworks (Next.js).</p>
      
      <p><strong>Choisissez Vue si :</strong> Productivité et DX maximale, performances critiques, équipe réduite ou progressive enhancement.</p>

      <h2 id="ressources">Ressources et liens utiles (février 2026)</h2>

      <h3>Angular</h3>
      <ul>
        <li>Site officiel & docs : <a href="https://angular.dev" target="_blank">https://angular.dev</a></li>
        <li>Blog Angular (release v21) : <a href="https://blog.angular.dev/announcing-angular-v21-57946c34f14b" target="_blank">Annonçant Angular v21</a></li>
        <li>Roadmap & releases : <a href="https://angular.dev/reference/releases" target="_blank">Versioning et calendrier</a></li>
        <li>Événement v21 : <a href="https://angular.dev/events/v21" target="_blank">Angular v21 Release</a></li>
      </ul>

      <h3>React</h3>
      <ul>
        <li>Site officiel & docs : <a href="https://react.dev" target="_blank">https://react.dev</a></li>
        <li>Versions & changelog : <a href="https://github.com/facebook/react/blob/main/CHANGELOG.md" target="_blank">GitHub Changelog (v19.2+)</a></li>
        <li>React 19 Deep Dive : <a href="https://react.dev/blog" target="_blank">Blog React (posts 2025)</a></li>
        <li>Next.js (meta-framework recommandé) : <a href="https://nextjs.org" target="_blank">https://nextjs.org</a></li>
      </ul>

      <h3>Vue.js</h3>
      <ul>
        <li>Site officiel & docs : <a href="https://vuejs.org" target="_blank">https://vuejs.org</a></li>
        <li>Releases & changelog : <a href="https://github.com/vuejs/core/blob/main/CHANGELOG.md" target="_blank">GitHub Core Changelog (v3.5.27)</a></li>
        <li>Vue 3.6 preview (perf + Vapor) : <a href="https://vueschool.io/articles/news/vn-talk-evan-you-preview-of-vue-3-6-vapor-mode/" target="_blank">Preview Vue 3.6 par Evan You</a></li>
        <li>Nuxt (meta-framework) : <a href="https://nuxt.com" target="_blank">https://nuxt.com</a></li>
      </ul>

      <h3>Comparaisons & analyses récentes</h3>
      <ul>
        <li>Angular vs React vs Vue perf 2026 : <a href="https://blog.logrocket.com/angular-vs-react-vs-vue-js-performance" target="_blank">LogRocket – Performance Guide 2026</a></li>
        <li>Quel framework apprendre en 2026 : <a href="https://dev.to/kafeel-ahmad/angular-vs-react-vs-vue-which-should-you-learn-in-2026-1ocg" target="_blank">DEV.to – Choix 2026</a></li>
        <li>Comparatif data-driven 2026 : <a href="https://imrankhani.medium.com/which-frontend-framework-should-you-learn-in-2026-a-data-driven-guide-92986c56e0dc" target="_blank">Medium – Guide data-driven</a></li>
      </ul>

      <h2 id="conclusion">Conclusion : Toujours pas de vainqueur absolu</h2>
      <p>En 2026, Angular, React et Vue sont tous excellents et matures. Le choix dépend avant tout de :</p>
      <ol>
        <li>Compétences et taille de l'équipe</li>
        <li>Complexité et durée de vie du projet</li>
        <li>Exigences perf/SEO/maintenance</li>
        <li>Écosystème et intégrations souhaitées</li>
      </ol>
      <p>Le meilleur framework est celui qui maximise la vélocité et la maintenabilité pour votre contexte spécifique. Une petite preuve de concept comparative reste souvent la meilleure façon de trancher sur un projet important.</p>
      
      <p><em>Note : L'écosystème évolue très vite. Cette analyse reflète l'état des lieux début février 2026. Vérifiez toujours les sites officiels pour les dernières releases.</em></p>
    `
  },
  {
  id: 202602041310,
  title: "Comment réussir son stage et augmenter ses chances de recrutement",
  excerpt: "Guide pratique 2026 pour transformer votre stage en IT/développement en tremplin vers un CDI : préparation, attitude sur place, visibilité, soft skills et stratégies pour décrocher une embauche à la fin.",
  category: "career",
  categoryText: "Carrière & Emploi IT",
  date: "04 Février 2026 13:10",
  datetime: "2026-02-04",
  img: "https://www.bizneo.com/blog/wp-content/uploads/2025/02/cout-recrutement.webp",
  author: "Équipe ITmaak TechDev",
  authorAvatar: "https://techdev.itmaak.com/img/logo.6ed77e12.png",
  readingTime: "5",
  content: `
    <h1>Comment réussir son stage et augmenter ses chances de recrutement en 2026</h1>

    <p>En 2026, un stage en informatique (dev web/mobile, data, DevOps, cybersécu…) reste l'une des meilleures portes d'entrée sur le marché du travail. Avec la pénurie de talents tech persistante, de nombreuses entreprises (startups, ESN, scale-ups, grands groupes) utilisent les stages comme vivier de recrutement : 30 à 50 % des stages de fin d'études se transforment en CDI quand le stagiaire performe bien. Mais comment se démarquer et maximiser ses chances ?</p>

    <p>Voici un guide concret : de la préparation avant le stage jusqu'aux dernières semaines décisives.</p>

    <h2>1. Bien préparer son stage avant le Jour J</h2>

    <ul>
      <li><strong>Choisir le bon stage</strong> : Priorisez les entreprises qui ont l'habitude de convertir en CDI (regardez les avis sur Glassdoor, Welcome to the Jungle, LinkedIn). Visez des missions alignées avec vos objectifs (ex. : full-stack React/Node si vous visez dev web, cloud/AWS pour DevOps).</li>
      <li><strong>CV et lettre de motivation tech</strong> : Mettez en avant projets perso/GitHub, portfolio (Netlify/Vercel), certifications (freeCodeCamp, AWS Certified, etc.). Personnalisez : mentionnez pourquoi cette entreprise/tech stack vous intéresse.</li>
      <li><strong>Préparez-vous techniquement</strong> : Revoyez les bases du stack de l'entreprise (ex. : React hooks, TypeScript, Docker si mentionné). Faites 1-2 mini-projets récents pour avoir des exemples frais à montrer.</li>
      <li><strong>Réseau LinkedIn</strong> : Connectez-vous avec des alumni/employés actuels. Posez une question polie sur le stage → ça montre de l'intérêt et crée un premier contact.</li>
    </ul>

    <h2>2. Les 10 attitudes qui font la différence pendant le stage</h2>

    <ol>
      <li><strong>Arrivez avec l'envie d'apprendre</strong> : Posez des questions intelligentes, notez tout, demandez du feedback hebdo. Montrez que vous progressez vite.</li>
      <li><strong>Soyez proactif</strong> : Ne restez pas bloqué 2 jours sur un bug sans demander de l'aide. Proposez des améliorations (refacto, tests, UX), même petites.</li>
      <li><strong>Communiquez bien</strong> : Daily stand-up clair, tickets Jira/Linear bien rédigés, updates Slack/Teams réguliers. Soft skills > code pur pour un junior.</li>
      <li><strong>Code propre & Git fluide</strong> : Commits clairs, PR bien décrits, respectez les conventions de l'équipe. Apprenez les revues de code.</li>
      <li><strong>Documentez votre travail</strong> : Créez un petit wiki perso (Notion/Markdown) sur ce que vous avez fait/appris → utile pour votre soutenance et pour montrer à votre tuteur.</li>
      <li><strong>Intégrez l'équipe</strong> : Participez aux rituels (retro, démos), afterworks si possible. Le fit culturel compte énormément pour un CDI.</li>
      <li><strong>Gérez votre temps</strong> : Livrez à temps, signalez les blocages tôt. Fiabilité = confiance.</li>
      <li><strong>Apprenez les outils internes</strong> : CI/CD, monitoring, auth, base de code legacy… Montrez que vous pouvez être autonome rapidement.</li>
      <li><strong>Créez de la valeur visible</strong> : Fixez des objectifs mesurables avec votre tuteur (ex. : "réduire le temps de build de 30 %", "ajouter 5 features").</li>
      <li><strong>Préparez votre "bilan stage"</strong> : Dès le milieu, listez vos contributions, apprentissages, metrics. Ça servira pour la discussion fin de stage.</li>
    </ol>

    <h2>3. Stratégies pour transformer le stage en CDI</h2>

    <ul>
      <li><strong>Exprimez votre intérêt tôt</strong> : Vers le mois 2-3, dites à votre manager/tuteur : "J'adore l'équipe et le projet, je serais très motivé pour continuer en CDI après le stage."</li>
      <li><strong>Parlez aux bonnes personnes</strong> : RH, lead dev, CTO. Montrez que vous comprenez les enjeux business de l'entreprise.</li>
      <li><strong>Obtenez des feedbacks formels</strong> : Demandez des points mid-stage et fin-stage. Corrigez vite les faiblesses.</li>
      <li><strong>Devenez "indispensable"</strong> : Prenez en charge des tâches récurrentes, formez les nouveaux arrivants, documentez des process.</li>
      <li><strong>Préparez votre soutenance comme un pitch CDI</strong> : Présentez vos réalisations + valeur ajoutée + vision pour l'avenir dans l'entreprise.</li>
      <li><strong>Ayez un plan B</strong> : Continuez à networker et postuler ailleurs pendant le stage (sans le crier sur les toits). Ça donne de la confiance.</li>
    </ul>

    <h2>4. Erreurs à éviter absolument</h2>

    <ul>
      <li>Rester passif : attendre qu'on vous dise quoi faire.</li>
      <li>Mauvaise communication : disparaître sur Slack, ne pas updater.</li>
      <li>Code "ça marche" sans qualité : pas de tests, code spaghetti.</li>
      <li>Ne pas demander de feedback : on pense qu'on fait bien, mais pas forcément.</li>
      <li>Ignorer la culture d'entreprise : arriver en retard aux meetings, ignorer les rituels.</li>
    </ul>

    <h2>Conclusion : Votre stage est votre meilleur entretien d'embauche</h2>

    <p>En 2026, le marché IT reste candidat-friendly pour les profils motivés et techniques. Un stage réussi n'est pas seulement une ligne sur le CV : c'est une preuve de 4-6 mois de performance réelle dans un contexte pro. Soyez curieux, fiable, visible et exprimez clairement votre envie de rester → vos chances de CDI explosent.</p>

    <p><strong>Bonus 2026</strong> : Mettez en avant des notions IA (prompt engineering, intégration LLM basique) ou cloud-native si possible → ça fait tilt chez beaucoup de recruteurs.</p>

    <p>Et vous ? Quel a été votre meilleur coup pour transformer un stage en job ? Partagez en commentaire !</p>

    <p><small>Note : Conseils basés sur tendances 2025-2026 (Welcome to the Jungle, Indeed, LinkedIn, retours d'anciens stagiaires IT en France/Europe).</small></p>
  `
},
{
  id: 202602041300,
  title: "Tutoriel Excel 2026 : De débutant à pro en maîtrisant les bases + IA",
  excerpt: "Guide pratique Excel 2026 : bases essentielles, formules puissantes, tableaux croisés dynamiques, Power Query, Copilot IA, et astuces pour booster votre productivité au quotidien (analyse de données, rapports, automatisations).",
  category: "dev",
  categoryText: "Développement & Outils",
  date: "4 Février 2026 13:00",
  datetime: "2026-02-04",
  img: "https://r.testifier.nl/Acbs8526SDKI/resizing_type:fit/width:3840/height:2560/plain/https://s3-newsifier.ams3.digitaloceanspaces.com/gizchina.com/images/2025-06/excel-ftr.webp@webp", 
  author: "Équipe ITmaak TechDev",
  authorAvatar: "https://techdev.itmaak.com/img/logo.6ed77e12.png",
  readingTime: "7",
  content: `
    <h1>Tutoriel Excel 2026 : De débutant à pro avec les nouveautés IA</h1>

    <p>En 2026, Excel n'est plus juste un tableur : c'est un outil d'analyse boosté à l'IA (Copilot), avec Power Query ultra-puissant et des fonctions dynamiques. Que vous gériez des budgets, analysiez des ventes ou prépariez des dashboards, ce tuto vous guide pas à pas.</p>

    <p><strong>Prérequis</strong> : Excel Microsoft 365 (version desktop ou web). Activez Copilot si disponible (via abonnement Microsoft 365 Copilot).</p>

    <h2>1. Les bases à maîtriser en 5 minutes</h2>

    <ul>
      <li><strong>Interface 2026</strong> : Ruban Accueil (police, alignement, format nombre), Insertion (graphiques, tableaux), Données (Power Query, TCD), Formules (fx).</li>
      <li><strong>Raccourcis indispensables</strong> :
        <ul>
          <li>Ctrl + T → Créer un Tableau (dynamique !)</li>
          <li>Ctrl + ; → Date du jour</li>
          <li>Alt + = → Somme automatique</li>
          <li>Ctrl + Maj + L → Filtrer le tableau</li>
          <li>F4 → Répéter dernière action / verrouiller référence ($)</li>
        </ul>
      </li>
      <li><strong>Tableaux structurés</strong> : Sélectionnez vos données → Ctrl + T. Avantage : formules auto-étendues, références lisibles (ex. [@Ventes] au lieu de C2).</li>
    </ul>

    <h2>2. Formules essentielles + modernes 2026</h2>

    <p>Commencez par les classiques, puis passez aux dynamiques (disponibles depuis 2021-2025, ultra-utiles).</p>

    <table>
      <thead>
        <tr><th>Fonction</th><th>Utilité</th><th>Exemple</th></tr>
      </thead>
      <tbody>
        <tr><td>SOMME.SI.ENS / NB.SI.ENS</td><td>Conditions multiples</td><td>=SOMME.SI.ENS(Ventes; Région;"Ouest"; Mois;"Jan")</td></tr>
        <tr><td>RECHERCHEV → XLOOKUP (mieux !)</td><td>Recherche avancée</td><td>=XRECHERCHE(A2; Produits[ID]; Produits[Prix]; "Non trouvé"; 0)</td></tr>
        <tr><td>FILTRE / TRIER / UNIQUE</td><td>Tableaux dynamiques</td><td>=FILTRE(A2:D100; C2:C100="Actif")</td></tr>
        <tr><td>SEQUENCE</td><td>Générer listes</td><td>=SEQUENCE(12;1;1;1) → 1 à 12</td></tr>
        <tr><td>SI + ET / OU</td><td>Logique</td><td>=SI(ET(A2>100; B2="Oui"); "Bonus"; "Standard")</td></tr>
      </tbody>
    </table>

    <p><strong>Astuce 2026</strong> : Tapez = puis décrivez en français ce que vous voulez → Copilot propose la formule ! Ex. : "Somme des ventes par région pour les mois > juin".</p>

    <h2>3. Mise en forme conditionnelle & Data Visualization</h2>

    <ul>
      <li><strong>Format conditionnel</strong> : Accueil → Mise en forme conditionnelle → Barres de données / Échelles de couleurs / Icônes.</li>
      <li><strong>Graphiques dynamiques</strong> : Insérez un graphique → utilisez un Tableau → il se met à jour auto.</li>
      <li><strong>Nouveauté</strong> : Copilot → "Crée un graphique en barres des ventes par produit" → il le génère + explique.</li>
    </ul>

    <h2>4. Tableaux Croisés Dynamiques (TCD) – Votre super-pouvoir</h2>

    <ol>
      <li>Sélectionnez données → Insertion → Tableau croisé dynamique.</li>
      <li>Glissez Champs : Lignes = Produit, Colonnes = Mois, Valeurs = Somme de Ventes.</li>
      <li>Ajoutez Segment (Slicer) : Insertion → Segment → filtre visuel.</li>
      <li><strong>2026 boost</strong> : Auto-refresh PivotTable (beta/Insiders) → données live.</li>
    </ol>

    <h2>5. Power Query : Nettoyage & transformation magique</h2>

    <p>Données → À partir d'une table/plage → Power Query s'ouvre.</p>

    <ul>
      <li>Supprimer doublons, diviser colonnes, fusionner tables.</li>
      <li>Appliquer → Fermer & charger → table propre.</li>
      <li><strong>Nouveauté web/desktop 2026</strong> : Power Query complet dans Excel web + import avancé.</li>
    </ul>

    <h2>6. Copilot & IA dans Excel 2026 (game changer)</h2>

    <ul>
      <li>Activez Copilot (ruban ou sidebar).</li>
      <li>Exemples de prompts :
        <ul>
          <li>"Résume ces données ventes 2025"</li>
          <li>"Ajoute une colonne marge = Ventes - Coût"</li>
          <li>"Crée un dashboard interactif"</li>
          <li>"Explique cette formule complexe"</li>
        </ul>
      </li>
      <li>Agent Mode (nouveau GA janv. 2026) : laissez l'IA "agent" analyser et proposer actions.</li>
    </ul>

    <h2>7. Astuces productivité 2026</h2>

    <ul>
      <li>Power Automate : Automatisez envoi rapport PDF par mail.</li>
      <li>Forms integration : Créez sondages → données direct dans Excel.</li>
      <li>Office Scripts (automatisation JS-like) : Enregistrez macros avancées.</li>
      <li>Raccourci : Ctrl + Maj + F → Rechercher dans formules.</li>
    </ul>

    <h2>Conclusion : Votre plan d'action</h2>

    <ol>
      <li>Jour 1-3 : Maîtrisez bases + tableaux + formules XLOOKUP/FILTRE.</li>
      <li>Semaine 2 : TCD + mise en forme + graphiques.</li>
      <li>Semaine 3+ : Power Query + Copilot IA pour analyses réelles.</li>
      <li>Pratiquez sur vos données perso/pro (ventes, budget, notes…).</li>
    </ol>

    <p><strong>Ressources gratuites 2026</strong> :
      <ul>
        <li>Support Microsoft : <a href="https://support.microsoft.com/fr-fr/excel">support.microsoft.com/fr-fr/excel</a></li>
        <li>Cours YouTube Oscar Aksanti (10h analyse données)</li>
        <li>Le Dojo Club : Guide complet + flashcards</li>
        <li>Simplilearn / Udemy : Cours gratuits/mis à jour 2026</li>
      </ul>
    </p>

    <p>Et vous ? Quelle est votre formule Excel préférée ou votre usage quotidien ? Partagez en commentaire !</p>

    <p><small>Note : Basé sur Excel Microsoft 365 – janvier/février 2026. Vérifiez les mises à jour via Fichier → Compte → Options de mise à jour.</small></p>
  `
},
{
  id: 202602041230,
  title: "Tutoriel Python 2026 : Apprendre de zéro à intermédiaire (avec Python 3.14)",
  excerpt: "Guide pas-à-pas pour débutants 2026 : installation, bases, structures de données, fonctions, boucles, gestion d'erreurs, et introduction aux nouveautés Python 3.14 (REPL moderne, erreurs claires, performance). Pratiquez avec des exemples concrets !",
  category: "dev",
  categoryText: "Développement",
  date: "4 Février 2026 12:30",
  datetime: "2026-02-04",
  img: "https://kunalcybersecurity.com/wp-content/uploads/2023/08/Python-Symbol.png", 
  author: "Mohamed Abderrahmann Ahmed",
  authorAvatar: "https://www.freeiconspng.com/uploads/face-head-man-icon-9.png",
  readingTime: "8",
  content: `
    <h1>Tutoriel Python 2026 : De zéro à intermédiaire avec Python 3.14</h1>

    <p>Python reste en 2026 le langage le plus populaire pour débuter en programmation, data science, automation, IA, web (Django/Flask/FastAPI), etc. Avec Python 3.14 (sorti octobre 2025), le REPL est plus beau, les messages d'erreur plus clairs, et le free-threading est officiellement supporté (pour les projets très parallèles).</p>

    <p>Ce tuto est fait pour les débutants : on commence de zéro et on monte progressivement. Testez chaque exemple dans votre éditeur !</p>

    <h2>1. Installation rapide (2026)</h2>

    <ol>
      <li>Téléchargez Python 3.14+ sur <a href="https://www.python.org/downloads/" target="_blank">python.org</a> → cochez "Add Python to PATH".</li>
      <li>Installez VS Code (gratuit) + extension Python (Microsoft) + Pylance.</li>
      <li>Alternative : utilisez <strong>Google Colab</strong> (en ligne, gratuit, GPU inclus) ou <strong>Replit</strong>.</li>
      <li>Vérifiez la version : ouvrez un terminal → tapez <code>python --version</code> → doit afficher Python 3.14.x</li>
    </ol>

    <h2>2. Votre premier programme – Hello World</h2>

    <p>Créez un fichier <code>hello.py</code> :</p>
    <pre><code>print("Bonjour le monde 2026 !")
nom = input("Comment vous appelez-vous ? ")
print(f"Salut {nom} ! Bienvenue en Python 3.14")</code></pre>

    <p>Exécutez : clic droit → "Run Python File in Terminal" (VS Code) ou terminal : <code>python hello.py</code></p>

    <h2>3. Variables & Types de données de base</h2>

    <pre><code># Pas besoin de déclarer le type (dynamique)
age = 25                # int
taille = 1.75           # float
nom = "Mohamed"         # str
est_dev = True          # bool
rien = None             # NoneType

print(type(age))        # &lt;class 'int'&gt;

# Python 3.14 : f-strings améliorées + template strings (t-strings expérimentales)
print(f"Bonjour {nom.upper()}, tu as {age} ans !")</code></pre>

    <h2>4. Opérations & Entrées/Sorties</h2>

    <pre><code>a = 10
b = 3
print(a + b)    # 13
print(a // b)   # division entière → 3
print(a ** 2)   # puissance → 100

texte = input("Entrez un nombre : ")
nombre = int(texte)   # conversion
print(nombre * 2)</code></pre>

    <h2>5. Conditions (if / elif / else)</h2>

    <pre><code>note = 14

if note >= 16:
    print("Excellent !")
elif note >= 10:
    print("Passable, continuez !")
else:
    print("Redoublement... travaille plus !")</code></pre>

    <h2>6. Boucles : for et while</h2>

    <pre><code># for ... range (très courant)
for i in range(5):          # 0 à 4
    print(i)

# for sur une liste
fruits = ["pomme", "banane", "kiwi"]
for fruit in fruits:
    print(f"J'aime les {fruit}s")

# while
compteur = 0
while compteur < 3:
    print("Tour", compteur)
    compteur += 1</code></pre>

    <h2>7. Listes, Tuples, Dictionnaires (collections)</h2>

    <pre><code># Liste (modifiable)
nombres = [1, 2, 3, 4]
nombres.append(5)
print(nombres[0])     # 1
print(len(nombres))   # 5

# Tuple (immuable)
coord = (48.85, 2.35)   # Paris
# coord[0] = 50 → ERREUR !

# Dictionnaire (clé:valeur)
etudiant = {
    "nom": "Ahmed",
    "age": 22,
    "notes": [15, 12, 18]
}
print(etudiant["nom"])
etudiant["ville"] = "Nouakchott"
print(etudiant)</code></pre>

    <h2>8. Fonctions (réutilisables)</h2>

    <pre><code>def saluer(prenom, age=20):    # paramètre par défaut
    return f"Salut {prenom} ! Tu as {age} ans."

print(saluer("Aicha"))
print(saluer("Omar", 25))

# Fonction avec *args (arguments variables)
def somme(*nombres):
    return sum(nombres)

print(somme(1, 2, 3, 10))   # 16</code></pre>

    <h2>9. Gestion des erreurs (try / except)</h2>

    <pre><code>try:
    x = int(input("Entrez un nombre : "))
    print(100 / x)
except ValueError:
    print("Ce n'est pas un nombre valide !")
except ZeroDivisionError:
    print("Division par zéro impossible.")
except Exception as e:
    print(f"Erreur inattendue : {e}")
finally:
    print("Fin du try/except")</code></pre>

    <h2>10. Nouveautés Python 3.14 à tester (2026)</h2>

    <ul>
      <li><strong>REPL coloré & auto-complétion intelligente</strong> : Lancez <code>python</code> dans terminal → tapez du code, c'est beau et aide !</li>
      <li><strong>Erreurs plus claires</strong> : Oubliez un parenthèse → message précis avec flèche pointant l'erreur.</li>
      <li><strong>Free-threading</strong> (expérimental → stable) : Pour parallélisme réel (option --disable-gil à l'installation pour tester).</li>
      <li><strong>Améliorations perf JIT</strong> : Code plus rapide sans rien changer (surtout boucles).</li>
    </ul>

    <h2>Plan d'action pour progresser vite</h2>

    <ol>
      <li>Semaine 1 : Bases + listes/dicts + fonctions</li>
      <li>Semaine 2 : Projets mini → calculatrice, jeu pierre-feuille-ciseaux, gestion liste de courses</li>
      <li>Semaine 3+ : Apprenez une lib → random, datetime, puis requests (API), pandas (données)</li>
      <li>Pratique quotidienne : 30-60 min sur <a href="https://exercism.org/tracks/python" target="_blank">Exercism</a>, <a href="https://www.codewars.com" target="_blank">Codewars</a> ou <a href="https://leetcode.com" target="_blank">LeetCode</a></li>
    </ol>

    <h2>Ressources gratuites 2026</h2>
    <ul>
      <li>Doc officielle (FR) : <a href="https://docs.python.org/fr/3/tutorial/" target="_blank">docs.python.org/fr/3/tutorial</a></li>
      <li>Python pour tous (gratuit) : <a href="https://www.py4e.com" target="_blank">py4e.com</a></li>
      <li>YouTube : "Python 2026 débutant" (ex. Bro Code, freeCodeCamp 4h cours)</li>
      <li>Interactif : Codecademy, DataCamp (Introduction Python), Mimo</li>
    </ul>

    <p>Et vous ? Quel est votre premier mini-projet Python ? Partagez en commentaire !</p>

    <p><small>Note : Tous les exemples testés avec Python 3.14 – février 2026. Bonne programmation ! 🐍</small></p>
  `
}
];